import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { getResponseMessage } from '../../../../utils/utils';
import { getManufacturer } from '../../../../crud/manufacturer.crud';
import { Manufacturer } from '../../../../interfaces/manufacturer';

export const useGetManufacture = () => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [manufacture, setManufacture] = useState<Manufacturer | null>(null);
  const handleManufacture = async (id: number) => {
    setLoading(true);
    getManufacturer(id)
      .then(res => {
        setManufacture(res.data.data);
      })
      .catch(e => {
        enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
          variant: 'error',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  
  return { handleManufacture, loading, manufacture, clear: () => setManufacture(null) };
};
